import { ProductSpecificService } from '@feature/product/services/product-specific.service';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';
import { Injectable } from "@angular/core";

@Injectable()
export class MfsProductService implements ProductSpecificService {

  static homeDashboard = 'mfs';
  static adminDashboard = 'mfs/admin-dashboard';
  static systemSettings = 'mfs/config';
  static manageProfiles = 'mfs/manage-profiles';
  static assignProfiles = 'mfs/assign-profiles';
  static manageWidgets = 'mfs/manage-widgets';
  static manageUsers = 'mfs/manage-users';

  product = MojoWellKnownNames.Products.MojoForSuppliers;
  adminDashboardRoute = '/mfs/admin-dashboard';
}

